const cContactFormInit = () => {
  const forms = document.querySelectorAll(
    "._form_7, ._form_9, ._form_11, ._form_13, ._form_49, ._form_45, ._form_51, ._form_53, ._form_55, ._form_57, ._form_59, ._form_61"
  );

  forms.forEach((form) => {
    const styleObj = form.querySelector("style");
    if (styleObj) {
      form.removeChild(styleObj);
    }

    /*const inputfields = form.querySelectorAll('input')
        inputfields.forEach(field => {
            field.removeAttribute('placeholder')
        })*/
  });
};

export default cContactFormInit;
